

























import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import {
  State,
  Getter,
  Action,
  Mutation,
  namespace,
} from 'vuex-class'
import moment from 'moment'

@Component
export default class NavigationDrawerRightComponent  extends Vue {
  @Prop() private value!: object

  get detail() {
    return this.value
  }

  set detail(val: any) {
    this.$emit('input', val)
  }

  private close() {
    this.detail = undefined
  }
}
